/**
 * @generated SignedSource<<8d3c64ed6619191681b88a9ba6acd816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OnboardingType = "CONFLUENCE_LINK" | "DATADOG_CI_EVENT_TYPE" | "DATADOG_DASHBOARD" | "DATADOG_DASHBOARD_DISCOVERY" | "DATADOG_EVENT_TYPE" | "DATADOG_LOG_TYPE" | "DATADOG_NOTEBOOK" | "DATADOG_RUM_TYPE" | "DATADOG_SPAN_TYPE" | "GCP_DASHBOARD" | "GCP_DASHBOARD_DISCOVERY" | "GITHUB_CODEBASE_ANALYSIS_INITIAL" | "GRAFANA_CLOUD_DASHBOARD" | "GRAFANA_CLOUD_DASHBOARD_DISCOVERY" | "GRAFANA_CLOUD_DATASOURCES" | "NEW_RELIC_APPLICATIONS" | "NEW_RELIC_DASHBOARD" | "NEW_RELIC_DASHBOARD_DISCOVERY" | "NEW_RELIC_LOG_TYPE" | "NEW_RELIC_METRICS" | "NEW_RELIC_SPAN_TYPE" | "NEW_RELIC_TRANSACTION_TYPE" | "NOTION_LINK" | "SANDBOX_IMAGE_BUILD" | "%future added value";
export type CreateOnboardingInput = {
  baseQueryFilter?: string | null | undefined;
  confluenceLinks?: string | null | undefined;
  dashboardIds?: string | null | undefined;
  dashboardUrls?: string | null | undefined;
  description?: string | null | undefined;
  integrationId?: string | null | undefined;
  name?: string | null | undefined;
  notionLinks?: string | null | undefined;
  resourceType: OnboardingType;
};
export type CreateOnboardingRequestMutation$variables = {
  input: CreateOnboardingInput;
};
export type CreateOnboardingRequestMutation$data = {
  readonly createOnboarding: {
    readonly error: string | null | undefined;
    readonly onboardingRequest: {
      readonly id: any;
      readonly onboardingType: OnboardingType;
      readonly status: string;
    } | null | undefined;
  };
};
export type CreateOnboardingRequestMutation = {
  response: CreateOnboardingRequestMutation$data;
  variables: CreateOnboardingRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOnboardingPayload",
    "kind": "LinkedField",
    "name": "createOnboarding",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLOnboardingQueue",
        "kind": "LinkedField",
        "name": "onboardingRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onboardingType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOnboardingRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOnboardingRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "702f12102ec30ad6ff1056f8d679469f",
    "id": null,
    "metadata": {},
    "name": "CreateOnboardingRequestMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOnboardingRequestMutation(\n  $input: CreateOnboardingInput!\n) {\n  createOnboarding(input: $input) {\n    onboardingRequest {\n      id\n      status\n      onboardingType\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "55c44f472e8f0c34a9568c9fdc204b2f";

export default node;
